module.exports = __webpack_public_path__ + "static/media/banner2.0377c7fb.png";